/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import $ from 'jquery';

import Reportes from './Reportes';

import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as cursoActions from '../../actions/cursoActions';
import * as inscripcionActions from '../../actions/inscripcionActions';
import * as pagosActions from '../../actions/pagosActions';

import * as infoActions from '../../actions/infoActions';
import * as resultadoExamenActions from '../../actions/resultadoexamenActions';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';


import { Segment} from 'semantic-ui-react';
import {usuarioActual} from '../../util';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import {getMargenes} from '../../util/';
import moment from 'moment';

class ManageReportes extends React.Component {
    constructor(props, context) {
		
		super(props, context);
        
      
        this.state={
            errors:{},
            strings:{}, 
            filtrosCombo:{},
            permisos:{} ,
            reporte:{},
            showModal:false,
            showModalAvance:false,
            registrosVacio:{
                inscripcion:[],
                modulos:0
            },
            registros:{
                inscripcion:[],
                modulos:0
            },
            quiz:null,
            curso:{
                modulos:null
                
            },
            reporteTipo:[{id:1, descripcion:"Alumnos reigstrados"},{id:2, descripcion:"Pagos pendientes"},{id:3, descripcion:"Constancias"},{id:4, descripcion:"Examenes"}],
            inscripcion:{
                inscripcion:[],
            },
            inscTemp:{
                inscripcion:[],
            },
            resultadosExamen:{
                resultadosExamen:[],
                examenes:[]
            },
            datosResultado:{},
            resultadoexamen:{},
            pagosVacio:[],
            pagos:[],
            constancias:[],
            examen:[]
		};
	}

	componentDidMount(){
        usuarioActual(this, "reporte",true).then( (usuario)=>{
            
            this.props.cursoActions.getCursoCombo(usuario).then(()=>{}) 
            .catch(error=>{ 
              toastr.error(error); 
            }); 
            
	   })
    }

    
    handleChangeExamen=(event, data)=>{
        
        let resultadoexamen = this.state.resultadoexamen;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		resultadoexamen[field[0]]= value;
		else{
             if(!resultadoexamen[field[0]]){
                    resultadoexamen[field[0]]={}
                }
			resultadoexamen[field[0]][field[1]]= value;
		}
        
		
        this.setState({"resultadoexamen": resultadoexamen});
        
        
    }
    
    handleChange=(event, data)=> {

        let reporte = this.state.reporte;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		reporte[field[0]]= value;
		else{
             if(!reporte[field[0]]){
                    reporte[field[0]]={}
                }
			reporte[field[0]][field[1]]= value;
		}
        
        if(field == 'cursoId'){
            this.setState({"cursoId":value});            
    
            
        }
		console.log(reporte);
        this.setState({"reporte": reporte});
    }

    consultar=()=>{
        let reporte = this.state.reporte;
        let pagos = this.state.pagosVacio;
        let registros = this.state.registrosVacio;
        this.setState({pagos:pagos, registros:registros});
        
        if(reporte.reporteTipo==1){
        
            this.props.inscripcionActions.getReporteInscripcion(reporte.cursoId, reporte.reporteTipo, this.props.user).then((inscripcion)=>{

                this.setState({registros:inscripcion, pagos:[], constancias:[], examen:[]});

            })
            .catch(error=>{ 
                toastr.error(error); 
            });
            
        } else if(reporte.reporteTipo==2){
        
                this.props.pagosActions.getReportePagos(reporte.cursoId, this.props.user).then( pagos=>{
                
                    for(let i=0; i< pagos.length; i++){
                        let A = moment(pagos[i].fechaPago2);
                        let dias = A.diff(this.state.fechaActual, 'days');

                        if(dias < 0){
                            pagos[i].atrasado=1;
                        }else{
                            pagos[i].atrasado=0;
                        }


                    }
                
                
                   this.setState({pagos:pagos,registros:this.state.registrosVacio, constancias:[], examen:[]});
            })
            .catch(error=>{
              toastr.error(error);
            });
                
            
        } else if(reporte.reporteTipo==3){
        
                this.props.inscripcionActions.getConstancias(reporte.cursoId, this.props.user).then( constancias=>{
                
                   this.setState({constancias:constancias,registros:this.state.registrosVacio, pagos:[], examen:[]});
            })
            .catch(error=>{
              toastr.error(error);
            });
                
            
        } else if(reporte.reporteTipo==4){
        
            console.log("Entro");
                this.props.resultadoExamenActions.getResultadoExamenCruso(reporte.cursoId, this.props.user).then( examen=>{
                
                   this.setState({examen:examen,registros:this.state.registrosVacio, pagos:[], constancias:[]});
            })
            .catch(error=>{
              toastr.error(error);
            });
                
            
        }

      
    }
    
    render() {
       
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda); 
		return (
            <Segment   style={margenes}>
                 
                <Reportes
                   cambiarEstatus={this.cambiarEstatus}
                    cambiarEstatusExamen={this.cambiarEstatusExamen}
                    strings={this.props.strings}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    id={this.state.id}
                    errores={this.state.errores}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    onChange={this.handleChange}
                    reporte={this.state.reporte}
                    errors={this.state.errors}
                    
                    download={this.download}
                    downloadExamen={this.downloadExamen}    
                    constancia={this.constancia}
                    onShowExamen={this.onShowExamen}
                    onShowAvance={this.onShowAvance}
                    
                    onChangeExamen={this.handleChangeExamen}
                    onSaveExamen={this.onSaveCalificacion}
                    consultar={this.consultar}
                    
                    reporteTipo={genericFormattedForDropdown(this.state.reporteTipo)}
                    registros={this.state.registros}
                    pagoReporte={this.state.pagos}
                    constancias={this.state.constancias}
                    examen={this.state.examen}
                />
                
             
            

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    
  
    
    return {
          

        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        color:state.color,
        strings:state.strings,
        idioma:state.idioma,
        user:state.user,
        cursoCombo:state.cursoCombo,
        inscripcion:state.inscripcion,
        resultadoexamen:state.resultadoexamen,
        inscripcionCombo:state.inscripcionCombo
    }

}


function mapDispatchToProps(dispatch){

	return { 
        menuActions:bindActionCreators(menuActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        cursoActions: bindActionCreators(cursoActions, dispatch),
        inscripcionActions:bindActionCreators(inscripcionActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        pagosActions: bindActionCreators(pagosActions, dispatch),
        resultadoExamenActions:bindActionCreators(resultadoExamenActions, dispatch),
        
 	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageReportes);